import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Mail, MapPin, Phone } from "lucide-react";

const LOGO_URL = "/slsa_logo_transparent.png";

const quickLinks = [
    { href: "/about", label: "About SLSA" },
    { href: "/donate", label: "Donate" },
    { href: "/events", label: "Events" },
    { href: "/gallery", label: "Gallery" },
    { href: "/sponsors", label: "Sponsors" },
    { href: "/get-involved", label: "Get Involved" },
    { href: "/contact", label: "Contact" },
];

export const Footer = () => (
    <footer className="bg-[#3D2008] text-[#F5EDD6] pt-16 pb-24 md:pb-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-12 pb-12 border-b border-[#C9A84C]/30">
                {/* Brand */}
                <div>
                    <img src={LOGO_URL} alt="SLSA" className="h-20 w-auto max-w-[160px] object-contain mb-4" />
                    <h3 className="font-anton text-[#F5EDD6] uppercase text-lg tracking-wide mb-2">
                        Seeley Lake Skatepark Association
                    </h3>
                    <p className="font-manrope text-sm leading-relaxed text-[#F5EDD6]/60 mb-6">
                        Building a free, modern skatepark in Seeley Lake, Montana. A safe, inclusive space for every rider of every age.
                    </p>
                    <div className="flex gap-3">
                        <a href="https://www.instagram.com/seeleylakeskatepark/" target="_blank" rel="noopener noreferrer" data-testid="footer-instagram"
                            className="p-2 bg-[#F5EDD6]/10 border border-[#C9A84C]/40 text-[#F5EDD6] hover:bg-[#C4522A] hover:border-[#C4522A] transition-colors duration-200">
                            <Instagram size={18} />
                        </a>
                        <a href="https://www.facebook.com/people/Seeley-Lake-Skatepark-Association/61589983814332/" target="_blank" rel="noopener noreferrer" data-testid="footer-facebook"
                            className="p-2 bg-[#F5EDD6]/10 border border-[#C9A84C]/40 text-[#F5EDD6] hover:bg-[#4A7FA5] hover:border-[#4A7FA5] transition-colors duration-200">
                            <Facebook size={18} />
                        </a>
                    </div>
                </div>

                {/* Quick Links */}
                <div>
                    <h4 className="font-anton text-[#C4522A] uppercase tracking-wide mb-6 text-lg">Quick Links</h4>
                    <ul className="space-y-0.5">
                        {quickLinks.map(link => (
                            <li key={link.href}>
                                <Link to={link.href}
                                    className="inline-block py-2 font-manrope text-sm text-[#F5EDD6]/70 hover:text-[#C9A84C] transition-colors duration-200">
                                    {link.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Contact + Fiscal Sponsor */}
                <div>
                    <h4 className="font-anton text-[#C4522A] uppercase tracking-wide mb-6 text-lg">Find Us</h4>
                    <div className="flex items-start gap-2 mb-4">
                        <MapPin size={16} className="text-[#C9A84C] mt-0.5 flex-shrink-0" />
                        <span className="font-manrope text-sm text-[#F5EDD6]/70">Seeley Lake, Montana 59868</span>
                    </div>
                    <div className="flex items-start gap-2 mb-3">
                        <Phone size={16} className="text-[#C9A84C] mt-0.5 flex-shrink-0" />
                        <a href="tel:+14064597079" className="font-manrope text-sm text-[#F5EDD6]/70 hover:text-[#C9A84C] transition-colors">
                            406-459-7079
                        </a>
                    </div>
                    <div className="flex items-start gap-2 mb-4">
                        <Mail size={16} className="text-[#C9A84C] mt-0.5 flex-shrink-0" />
                        <a href="mailto:info@seeleyskatepark.org" className="font-manrope text-sm text-[#F5EDD6]/70 hover:text-[#C9A84C] transition-colors">
                            info@seeleyskatepark.org
                        </a>
                    </div>
                </div>
            </div>

            {/* Bottom bar */}
            <div className="pt-6 flex flex-col sm:flex-row justify-between items-center gap-3">
                <p className="font-manrope text-xs text-[#F5EDD6]/40">
                    © 2025 Seeley Lake Skatepark Association. All rights reserved.
                </p>
                <p className="font-marker text-[#C9A84C] text-base">Build It. Ride It. Own It.</p>
            </div>
        </div>
    </footer>
);

export default Footer;
